export const RESULT_TYPES = {
  PROVIDER: 'provider',
  LOCATION: 'location',
};

export const VIEW_MODES = {
  DEFAULT: 'default',
  TEASER: 'teaser',
  VIRTUAL_URGENT_CARE_CLOSED: 'virtual_urgent_care_closed',
  VIRTUAL_URGENT_CARE_IN_QUEUE: 'virtual_urgent_care_in_queue',
  VIRTUAL_URGENT_CARE_LAUNCH_VISIT: 'virtual_urgent_care_launch_visit',
  VIRTUAL_URGENT_CARE_OPEN: 'virtual_urgent_care_open',
};
